/* eslint-disable @typescript-eslint/ban-ts-comment */
import React from 'react'
import Box from '@mui/material/Box'

// COMPONENTS
import { EmtChip, EmtTypography, EmtIcon, useMobile } from 'emt-components-v2'
import { LightBox, LightBoxChips } from '../../Profile/partials/StyledComponents'

// TYPES
import { BadgeGroup } from '@/data/PetSitter/PetSitterProfile'

type Props = {
  data: BadgeGroup
}

export const List: React.FC<Props> = ({ data }) => {
  const [isMobile, isTablet] = useMobile()

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: isMobile || isTablet ? 'column' : 'row',
        gap: '24px',
      }}
    >
      {/* @ts-ignore */}
      <LightBox sx={{ minHeight: '0', backgroundColor: '#fff' }}>
        <EmtTypography variant="h5" fontWeight={700}>
          {data.label}
        </EmtTypography>
        <LightBoxChips>
          {data.badges.map((badge, key) => {
            const isActive = badge.color !== 'default' || badge.label.icon === 'emt-tick'
            return (
              <EmtChip
                key={key}
                variant={isActive ? 'filled' : 'disabled'}
                color={isActive ? 'successlight' : 'greylight'}
                label={badge.label.label}
                icon={<EmtIcon className={badge.label.icon} sx={{ fontWeight: 100, width: 19 }} />}
              />
            )
          })}
        </LightBoxChips>
      </LightBox>
    </Box>
  )
}
